import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/identity/$id')({
  beforeLoad: () => getTitleContextSlice('Identity'),
});
